import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'messages'
const verb = 'post'

export default class OspreyMessagesCopy extends BaseAction {
    constructor(dataKey) {
        const id = '33392ed8-6046-11e9-8e2d-2f3fd94c8e6f'
        const path = `/${resource}/copy`
        super(resource, verb, path, id, dataKey)
        this.noCache = true

        this.onError = () => true
    }

    copy(params) {
        this.params = params
        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/messages/messages-copy.js